import { Box, Button, FormControl, IconButton, List, ListItem, Menu, MenuItem, Select, useTheme } from '@mui/material'
import React from 'react'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';

function SubjectConstraintProperties(props) {

    const theme = useTheme();

    const {
        subjectConstraints,
        handleOpenCreateSubjectConstraint,
        handleConditionMenuOpen,
        handleChangeSubjectConstraintConjunction,
        renderSubjectConstraintChip,
        handleConditionMenuClose,
        handleOpenEditCreateSubjectConstraint,
        handleDeleteSubjectConstraint,
        anchorElCondition,
        disabled
    } = props;

    const filter_inherited = subjectConstraints.filter(group => group.inherited === true);

    return (
        <div>
            <List sx={{ padding: '0px' }}>
                {subjectConstraints.map((group, outerIndex) => {
                    return (
                        <Box key={outerIndex}>
                            {!group?.inherited ?
                                <ListItem
                                    sx={{
                                        position: 'relative',
                                        border: '1px solid #ccc',
                                        margin: '10px 0px',
                                        padding: '5px 5px 0px 5px',
                                        borderRadius: '5px',
                                        borderColor: group?.error ? theme.palette.error.main : '#ccc',
                                    }}
                                    key={outerIndex}
                                    secondaryAction={
                                        <IconButton
                                            sx={{
                                                position: 'absolute',
                                                right: (theme) => theme.spacing(-2.2),
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                            }}
                                            aria-label="more"
                                            onClick={(e) => handleConditionMenuOpen(e, outerIndex)}
                                        >
                                            <MoreVertIcon />
                                        </IconButton>
                                    }
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            maxWidth: '100%',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {renderSubjectConstraintChip(group)}
                                    </Box>
                                </ListItem>
                                :
                                <ListItem
                                    sx={{
                                        position: 'relative',
                                        border: '1px solid #ccc',
                                        margin: '10px 0px',
                                        padding: '5px 5px 0px 5px',
                                        borderRadius: '5px',
                                        borderColor: group?.error ? theme.palette.error.main : '#ccc',
                                    }}
                                    key={outerIndex}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            maxWidth: '100%',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {renderSubjectConstraintChip(group)}
                                    </Box>
                                </ListItem>
                            }
                            {group.conjunction !== "" && (
                                <Box>
                                    <FormControl size="small" sx={{ minWidth: 100 }} fullWidth>
                                        <Select
                                            value={group?.conjunction}
                                            readOnly={(group?.inherited && outerIndex < filter_inherited.length - 1)}
                                            onChange={(e) => handleChangeSubjectConstraintConjunction(outerIndex, 'conjunction', e.target.value)}
                                        >
                                            <MenuItem value="AND">AND</MenuItem>
                                            <MenuItem value="OR">OR</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            )}
                        </Box>
                    )
                })}
            </List>
            <Button
                sx={{
                    border: '1px solid #ccc',
                    mt: 1,
                    '&.Mui-disabled': {
                        bgcolor: theme.palette.action.disabledBackground,
                        color: theme.palette.action.disabled,
                    },
                }}
                variant="outlined"
                fullWidth
                disabled={disabled}
                onClick={() => handleOpenCreateSubjectConstraint()}
            >
                <AddIcon color='action' />
            </Button>
            <Menu
                anchorEl={anchorElCondition}
                open={Boolean(anchorElCondition)}
                onClose={handleConditionMenuClose}
            >
                <MenuItem onClick={handleOpenEditCreateSubjectConstraint}>Edit</MenuItem>
                <MenuItem onClick={handleDeleteSubjectConstraint}>Delete</MenuItem>
            </Menu>
        </div>
    )
}

export default SubjectConstraintProperties